module.exports = __webpack_public_path__ + "img/ESG_Utmutato_Kockazatkezeles_boritokep.7f1ba34b.webp";